import { ProfessionModule } from '@/store/modules/profession';
import { CountType } from '@/types/ProfessionType';

export default {
  methods: {
    getKleCountsApi(this: any) {
      const defaultCountParams = {
        sid: this.languageSid,
        count: 1,
      };
      this.$nextTick(() => {
        const { employmentCount } = ProfessionModule;
        const needEmployment = this.isSearchTriggered
          || employmentCount.fulltime == null
          || employmentCount.parttime == null
          || employmentCount.edujob == null
          || employmentCount.minijob == null
          || employmentCount.praktikum == null;
        if (needEmployment) {
          this.loadingEmploymentCount = true;
          const load1 = ProfessionModule.GetJobsCount({
            filter: CountType.fulltime,
            params: {
              ...defaultCountParams,
              edujob: 1,
              praktikum: 1,
              parttime: 1,
              minijob: 1,
            },
          });
          const load2 = ProfessionModule.GetJobsCount({
            filter: CountType.parttime,
            params: {
              ...defaultCountParams,
              edujob: 1,
              praktikum: 1,
              fulltime: 1,
              minijob: 1,
            },
          });
          const load3 = ProfessionModule.GetJobsCount({
            filter: CountType.minijob,
            params: {
              ...defaultCountParams,
              edujob: 1,
              praktikum: 1,
              fulltime: 1,
              parttime: 1,
            },
          });
          const load4 = ProfessionModule.GetJobsCount({
            filter: CountType.edujob,
            params: {
              ...defaultCountParams,
              praktikum: 1,
              fulltime: 1,
              parttime: 1,
              minijob: 1,
            },
          });
          const load5 = ProfessionModule.GetJobsCount({
            filter: CountType.praktikum,
            params: {
              ...defaultCountParams,
              edujob: 1,
              fulltime: 1,
              parttime: 1,
              minijob: 1,
            },
          });
          Promise.all([load1, load2, load3, load4, load5]).finally(() => {
            this.loadingEmploymentCount = false;
          });
        }

        const needArbeitgeberart = this.isSearchTriggered
          || employmentCount.dejob == null
          || employmentCount.recruit == null
          || employmentCount.tmpjob == null;
        if (needArbeitgeberart) {
          this.loadingArbeitgeberartCount = true;
          const load6 = ProfessionModule.GetJobsCount({
            filter: CountType.dejob,
            params: {
              ...defaultCountParams,
              recruit: 1,
              tmpjob: 1,
            },
          });
          const load7 = ProfessionModule.GetJobsCount({
            filter: CountType.recruit,
            params: {
              ...defaultCountParams,
              dejob: 1,
              tmpjob: 1,
            },
          });
          const load8 = ProfessionModule.GetJobsCount({
            filter: CountType.tmpjob,
            params: {
              ...defaultCountParams,
              dejob: 1,
              recruit: 1,
            },
          });
          Promise.all([load6, load7, load8]).finally(() => {
            this.loadingArbeitgeberartCount = false;
          });
        }

        const needStellenherkunft = this.isSearchTriggered
          || employmentCount.partner_jobs_only == null
          || employmentCount.other_jobs == null
          || employmentCount.amsjob == null;
        if (needStellenherkunft) {
          this.loadingStellenherkunftCount = true;
          const load9 = ProfessionModule.GetJobsCount({
            filter: CountType.partner_jobs_only,
            params: {
              ...defaultCountParams,
              other_jobs: 1,
              amsjob: 1,
            },
          });
          const load10 = ProfessionModule.GetJobsCount({
            filter: CountType.other_jobs,
            params: {
              ...defaultCountParams,
              bajob: 1,
            },
          });
          const loadAmsjob = ProfessionModule.GetJobsCount({
            filter: CountType.amsjob,
            params: {
              ...defaultCountParams,
              extba: 1,
            },
          });
          Promise.all([load9, load10, loadAmsjob]).finally(() => {
            this.loadingStellenherkunftCount = false;
          });
        }

        const needLocationCount = this.isKleLocationCountryFilter
          && (this.isSearchTriggered
            || employmentCount.location_germany == null
            || employmentCount.location_netherlands == null);
        if (needLocationCount) {
          this.loadingLocationCount = true;
          const load11 = ProfessionModule.GetJobsCount({
            filter: CountType.location_germany,
            params: {
              ...defaultCountParams,
              location_id: 1206,
              jobnews_type: 1,
            },
          });
          const load12 = ProfessionModule.GetJobsCount({
            filter: CountType.location_netherlands,
            params: {
              ...defaultCountParams,
              location_id: 1227,
              jobnews_type: 1,
            },
          });
          Promise.all([load11, load12]).finally(() => {
            this.loadingLocationCount = false;
          });
        }
      });
    },
  },
};
